export const SkeletonTextSize = {
  h1: '2.5rem',
  h2: '2rem',
  h3: '1.75rem',
  h4: '1.5rem',
  h5: '1.25rem',
  h6: '1rem',
  subtitle1: '1.25rem',
  subtitle2: '1rem',
  caption1: '0.75rem',
  caption2: '0.625rem',
  body1: '1rem',
  body2: '0.875rem',
} as const
